import React, { useEffect, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from 'src/store/hooks';
import { queryParams } from "src/helpers/UrlHelpers";
import { fetchCdrs } from "src/actions/callrecorder/cdrsActions";
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

import PageLayout from '../_partials/PageLayout';
import ListTable from "./_partials/_ListTable";
import PageHeader from "src/componets/PageHeader";
import Wrapper from "src/componets/Wrapper";
import Filter from "src/componets/Filter";

const LIMIT = 42;
const DEFAULT_ORDER_BY = 'id';

const NAV_ITEMS: {[index: number]: any} = {
  1: { id: 1, name: 'Incoming',  url: callrecorderUrls.cdrsPath({ order_by: DEFAULT_ORDER_BY, call_type: 'incoming' }) },
  2: { id: 2, name: 'Outgoing',  url: callrecorderUrls.cdrsPath({ order_by: DEFAULT_ORDER_BY, call_type: 'outgoing' }) },
  3: { id: 3, name: 'Reminder',  url: callrecorderUrls.cdrsPath({ order_by: DEFAULT_ORDER_BY, call_type: 'reminder' }) },
};

const Cdrs = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;
  const { pathname } = useLocation();

  const activeNavId = useMemo(() => {
    const callType = searchParams.get('call_type');
    if (callType === 'incoming') return 1;
    if (callType === 'outgoing') return 2;
    if (callType === 'reminder') return 3;
    return undefined;
  }, [searchParams]);

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'search_by', 'order_by', 'order', 'date_from', 'date_to', 'disposition', 'user_id', 'call_type']
    );

    dispatch(fetchCdrs(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  return (
    <PageLayout className='v-cdrs'>
      <PageHeader
        title='CDRs'
        navs={NAV_ITEMS}
        activeId={activeNavId}
        parent={{
          name: 'All',
          url: callrecorderUrls.cdrsPath({ order_by: DEFAULT_ORDER_BY })
        }}
      />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter dateRange />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>
    </PageLayout>
  );
}

export default Cdrs;
